<template>
	<div
		class="relative inline-block tooltip-box"
		@mouseover="showTooltip"
		@mousemove="updateTooltipPosition"
		@mouseleave="hideTooltip"
	>
		<slot />
		<div
			v-show="isVisible"
			:style="tooltipStyle"
			:class="
				`absolute p-2 bg-${bgColor} text-${textColor} text-left rounded-lg max-w-sm transition-all duration-500 ease-in-out tooltip z-20`
			"
		>
			<span class="whitespace-pre-wrap">{{ text }}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AppTooltip',
		props: {
			text: {
				type: [String, Number],
				required: true,
			},
			bgColor: {
				type: String,
				default: 'gray-600',
			},
			textColor: {
				type: String,
				default: 'white',
			},
		},
		data() {
			return {
				tooltipStyle: {
					top: '0px',
					left: '0px',
				},
				isVisible: false,
			};
		},
		methods: {
			showTooltip(event) {
				this.isVisible = true;
				this.updateTooltipPosition(event);
			},
			hideTooltip() {
				this.isVisible = false;
			},
			updateTooltipPosition(event) {
				const tooltipWidth = 200;
				const tooltipHeight = 50;
				const offsetX = 10;
				const offsetY = 10;

				let top = event.clientY + offsetY;
				let left = event.clientX + offsetX;

				if (left + tooltipWidth > window.innerWidth) {
					left = window.innerWidth - tooltipWidth - offsetX;
				}

				if (top + tooltipHeight > window.innerHeight) {
					top = window.innerHeight - tooltipHeight - offsetY;
				}

				this.tooltipStyle = {
					top: `${top}px`,
					left: `${left}px`,
				};
			},
		},
	};
</script>

<style scoped>
	.tooltip-box {
		position: relative;
	}

	.tooltip {
		position: fixed;
		width: auto;
		height: auto;
	}

	.tooltip .arrow {
		position: absolute;
		width: 0;
		height: 0;
		top: -5px;
		left: 50%;
		transform: translateX(-50%);
	}
</style>
